module.exports = __webpack_public_path__ + "img/52.f6ed5527.jpg";